import SmartGroupTableView from './smart-group-view-student-behavior';
export default SmartGroupTableView;
